import React, { useState } from 'react'
import { Drawer, Tabs, DatePicker, Menu, Dropdown, Badge } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import moment from 'moment'

import { presets, usePet, useToggle } from '../../modules'

import LineChart02 from '../../charts/LineChart02'

import { tailwindConfig } from '../../utils/Utils'
import Receive from '../reusable/receive'

const { RangePicker } = DatePicker

const Movement = () => {
    const [movement, setMovement] = useState({ labels: [], datasets: [] })

    const [ranges, setRanges] = useState([moment().startOf('week'), moment().endOf('week')])

    const { id, store } = useParams()

    const [{ error, loading }, getMovement] = usePet('itemMovement', ranges ? {
        id,
        store,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
    } : {
        id,
        store,
    }, {
        notify: true, callback: ({ data }) => {
            let labels = Object.keys(data)
            
            let keys = ["patientRequests", "departmentRequests", "prescriptions", "consumables", "externalTransfers"]

            let dataset = {}
            for (let key of keys)
                dataset[key] = { 
                    label: key, 
                    data: [], 
                    borderColor: tailwindConfig().theme.colors.indigo[500],
                    fill: false,
                    borderWidth: 2,
                    tension: 0,
                    pointRadius: 0,
                    pointHoverRadius: 3,
                    pointBackgroundColor: tailwindConfig().theme.colors.indigo[500]                    
                }
            
            for (let date in data)
                Object.keys(data[date])
                    .forEach(key => 
                        dataset[key].data.push(data[date][key]))

            setMovement({ labels, datasets: Object.values(dataset) })
        }
    })

    const history = useHistory()

    const selectRange = range => {
        setRanges(range)
        getMovement()
    }

    const [visible, toggleVisible] = useToggle(true)

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                </div>
            }
            width={800}>
            <p className="font-extrabold text-3xl mb-0">Item Movement</p>
            <div className="grid grid-flow-col sm:auto-cols-max justify-end gap-2">
                <RangePicker value={ ranges } onChange={selectRange} ranges={ presets } />
            </div>
            <Receive
                error={ error }
                loading={ loading }
                progress>
                <LineChart02 data={ movement } width={595} height={248} />
            </Receive>
        </Drawer>
    )
}

export default Movement